module.exports = __webpack_public_path__ + "img/bg4.c72d9997.jpg";